import React from 'react'
import { logoBannerStyles } from './logo-banner-style'
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { CdnImg } from '@/features/cdn-img';

export const LogoBanner = () => {
	const SiteConfigData = useGetSiteConfigs();
	const siteId = SiteConfigData.SiteConfigsData?.GetMessageID?.substring(0, 5) || '';

	return (
		<div className={logoBannerStyles.banner}>
			<div className={logoBannerStyles.logo}>
				<CdnImg
					src={`/images/jupiter/${siteId}/logo_large.png`}
					alt="App logo"
				/>
			</div>
		</div>
	)
}
